import React from 'react';
import { Row, Col, FormGroup, Button, Glyphicon } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { SponsorHistoryItem } from 'areas/shared/controls'
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';
import { ActionButton, Label } from 'fw/components';
import { TextBox } from 'fw/forms';
import * as Block from 'fw/globals/Block';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import * as FormManager from 'fw/forms/form/FormManager'

class SponsorHistoryDetail extends SetupTab {
	initialForm = () => {
		return {
			title: "",
			sponsorHistoryId: null,
			paypalInvoiceId: null,
			paypalInvoiceItemId: null,
			sponsorHistoryItems: [],
			searchInvoiceNumber: "",
			invoiceBillingBusinessName: ""
		};
	}

	privileges() {
        return {
            add: App.hasPrivilege("AdminSponsorSetupAdd"),
            edit: App.hasPrivilege("AdminSponsorSetupEdit")
        }
    }

	urls() {
        return {
            get: API.Sponsor.url('/sponsorSetup/getSponsorHistoryInfo'),
            save: API.Sponsor.url('/sponsorSetup/saveSponsorHistoryInfo'),
            create: API.Sponsor.url('/sponsorSetup/createSponsorHistoryInfo')
        }
    }

	getRequest = (selectedId) => {
		return {
			sponsorHistoryId: selectedId,
		};
	}

	validate = (cb) => {
        for (var ref in this.refs) {
            this._form.register(this.refs[ref]);
        }

		if (this.props.adding && ( !this.state.form.items || this.state.form.items.maxLength === 0))
		{
			if (this.state.form.searchInvoiceNumber)
				this.handleFindInvoice();
			
			return;
		}
        
		if (!this._form.validate())
			return false;

		return true;
    }

	saveRequest = () => {
		return {
			sponsorId: this.props.masterId,
			sponsorHistoryId: this.props.selectedId,
			paypalInvoiceId: this.state.form.paypalInvoiceId,
			sponsorHistoryItems: this.state.form.items,
			rowVersion: this.state.form.rowVersion
		};
	}

	ready = () => {
		this.focusControl && this.focusControl.focus();
	}

	handleItemChange = (v, i) => {
		const items = this.state.form.items;
		
        items[i] = v;
		
        this.setState({ form: { ...this.state.form, items } });
        this.dirt();
    }

	renderItems = () => {
		if (this.state.form && this.state.form.items)
		{
			const checkMembership = (item) => item.isMembership;
			let existMembership = this.state.form.items.some(checkMembership);

			return (
				this.state.form.items.map((item, i) => (
					<div key={item.paypalInvoiceItemId}>
						<SponsorHistoryItem
							value={item}
							disabledMembership={existMembership}
							sponsorHistoryId={item.sponsorHistoryId}
							paypalInvoiceItemId={item.paypalInvoiceItemId}
							onChange={(v) => this.handleItemChange(v, i)}
							required={false}
							ref={`item_${i}`}
						/>
						{ (i+1) < this.state.form.items.length ?
							<hr />
						: 
							<div>
								<br />
								<br />
							</div>
						}
					</div>
				))
			)
		}
    }

	handleDelete = () => {
		const me = this;
		
		Modals.remove({
			title: 'Removing invoice',
			elementType: 'invoice #',
			name: me.state.form.title,
			onYes: () => {
				API.Sponsor.post('/sponsorSetup/removeSponsorHistoryInfo', { sponsorHistoryId: me.props.selectedId, rowVersion: me.state.form.rowVersion },
					{
						success: (r) => {
							me.props.onSuccess(r.message);
							me.props.onDelete();
							me.props.onCancel();
						},
						error: (r) => {
							me.props.onError(r.error);
						},
					});
			},
		});
	}

	handleFindInvoice = () => {
		Block.block();
		let searchInvoiceNumber = this.state.form.searchInvoiceNumber;

		const rq = {
			invoiceNumber: searchInvoiceNumber,
			sponsorId: this.props.masterId
		};

		API.Sponsor.get('/sponsorSetup/getSponsorHistoryScreenByInvoice',
			rq,
			{
				success: (r) => {
					this.setState({
						form: {
							...r.data,
							original: JSON.parse(JSON.stringify(r.data)),
						},
					});
					Block.unblock();
				},
				error: (r) => {
					this.props.onError(r.error);
					this.setState({
						form: {
							...this.initialForm(),
							searchInvoiceNumber: searchInvoiceNumber
						},
					});
					FormManager.reset();
					Block.unblock();
				},
			},
			{ block: false }
		);
	};

	renderBusinessName = () => {
		if (!this.state.form.invoiceBillingBusinessName)
			return null;
		
		let color = "#721c24";
		let backgroundColor = "#f8d7da";
		let borderColor= "#f5c6cb";

		if (this.state.form.sameBusinessName)
		{
			color = "#1a663e";
			backgroundColor = "#86bfa1";
			borderColor= "#c9f2d4";
		}
		
		return (
			<div className="alert" style={{ marginTop: "22px", textAlign: "center", color: color, backgroundColor: backgroundColor, borderColor: borderColor }}>
				Invoice Billed To (Business Name):<strong> {this.state.form.invoiceBillingBusinessName}</strong>
				{ !this.state.form.sameBusinessName ?
					<strong>
						<br />
						<FontAwesomeIcon icon={faExclamationTriangle} size="1x" />
						&nbsp;&nbsp;Attention! Retrieved Invoice Business Name does not match with Corporate Member name.
					</strong>
				: null }
			</div>
		);
	}

	renderForm = () => {
		return (
			<React.Fragment>
				{ this.props.adding ?
					<React.Fragment>
						<Row>
							<Col md={12}>
								<h3 className="inline">
									Add new Invoice
								</h3>
							</Col>
						</Row>
						<hr />
						<Row>
							<Col md={2}>
								<FormGroup>
									<Label required>Invoice Number</Label>
									<TextBox
										placeholder="Invoice Number"
										name="searchInvoiceNumber"
										maxLength={10}
										required 
										ref={(c) => { this.focusControl = c; }} />
									<Button
										variant="default"
										size="xs"
										block
										onClick={this.handleFindInvoice}
									>
										Search Invoice &nbsp; <Glyphicon glyph="search" />
									</Button>
								</FormGroup>
							</Col>
							<Col md={10}>
								{this.renderBusinessName()}
							</Col>
						</Row>
						<hr />
						<Row>
							<Col md={12}>
								{this.renderItems()}
							</Col>
						</Row>
					</React.Fragment>
				:
					<React.Fragment>
						<Row>
							<Col md={8}>
								<h3 className="inline">
									Invoice # {this.state.form.title}
								</h3>
							</Col>
							<Col md={4}>
								{true ?
									<span className="pull-right" style={{textAlign:"right"}}>
										<ActionButton 
											id="btRemoveAssociation" 
											onClick={this.handleDelete} 
											icon="trash">
												Remove Invoice
										</ActionButton>
									</span>
								: null}
							</Col>
						</Row>
						<hr />
						{this.renderItems()}
					</React.Fragment>
				}
				<br />
			</React.Fragment>
		);
	}
}

export default SponsorHistoryDetail;



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/sponsorHistory/SponsorHistoryDetail.js